module.exports = __webpack_public_path__ + "static/video-db532af1eceddce81ed6fc64827dcc3f.png";